<button type="button" [ngClass]="{
  'textButton': textButton, 'borderButton' : borderButton , 'blackTextButton': blackTextButton , 'shineButton': shineButton, 'disabled-button': disabled}" (click)="onClickAction()" *ngIf="!innerHtmlButtonName">
  <i [class]="iconName" *ngIf="iconName"></i>
  <span *ngIf="buttonName">{{ buttonName | translate }}</span>
</button>

<button type="button" [ngClass]="{
  'textButton': textButton, 'borderButton' : borderButton, 'blackTextButton': blackTextButton , 'shineButton': shineButton, 'disabled-button': disabled }" (click)="onClickAction()" [innerHtml]="innerHtmlButtonName | translate" *ngIf="innerHtmlButtonName">
  <i [class]="iconName" *ngIf="iconName"></i>
</button>
